import { z } from 'zod'

const ResetPasswordBaseSchema = z.object({
  newPassword: z
    .string()
    .min(8, 'Password must be at least 8 characters')
    .regex(/[0-9]/, 'Password must contain at least 1 number')
    .regex(/[a-z]/, 'Password must contain at least 1 lowercase letter')
    .regex(/[A-Z]/, 'Password must contain at least 1 uppercase letter'),
  confirmPassword: z.string(),
})

export const ResetPasswordSchema = ResetPasswordBaseSchema.superRefine(
  (data, ctx) => {
    if (data.newPassword !== data.confirmPassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Passwords do not match',
        path: ['confirmPassword'],
      })
    }
  },
)

const UpdatePasswordBaseSchema = ResetPasswordBaseSchema.extend({
  currentPassword: z
    .string()
    .min(8, 'Current password must be at least 8 characters'),
})

export const UpdatePasswordSchema = UpdatePasswordBaseSchema.superRefine(
  (data, ctx) => {
    if (data.newPassword !== data.confirmPassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Passwords do not match',
        path: ['confirmPassword'],
      })
    }
  },
)

export type ResetPasswordData = z.infer<typeof ResetPasswordSchema>
export type UpdatePasswordData = z.infer<typeof UpdatePasswordSchema>
